<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function () {
  const paramsToRemove = [
    'shpxid',
    '_ab',
    '_fd',
    'pb',
    'sca_ref',
    'utm_source',
    'utm_medium',
    'utm_campaign'
  ];

  const url = new URL(window.location.href);
  let changed = false;

  paramsToRemove.forEach(p => {
    if (url.searchParams.has(p)) {
      url.searchParams.delete(p);
      changed = true;
    }
  });

  if (changed) {
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
})();


// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('.number-showmore');
//   if (!btn) return;

//   const productId = btn.dataset.productId;
//   const dataEl = document.getElementById('swatch-data-' + productId);
//   if (!dataEl) return;

//   const variants = JSON.parse(dataEl.textContent);
//   const ul = btn.closest('ul');
//   const group = ul.querySelector('.group-swatch');

//   if (!group) return;

//   variants.slice(4).forEach(variant => {
//     const wrapper = document.createElement('div');
//     wrapper.className = 'item-wrapper clearfix';

//     wrapper.innerHTML = `
//       <label class="swatch-label
//         ${variant.available === false ? 'is-soldout' : ''}"
//         data-variant-id="${variant.id}"
//         data-value="${variant.text}"
//         ${variant.big_img ? `data-variant-img="${variant.big_img}"` : ''}>
//         <span class="pattern"
//           style="${variant.variant_img ? `background-image:url(${variant.variant_img});` : ''}">
//         </span>
//         ${variant.text}
//       </label>
//       <span class="tooltip">${variant.color}</span>
//     `;

//     group.appendChild(wrapper);
//   });

//   // Hiện group-swatch
//   group.style.display = 'flex';

//   // Xóa nút More
//   btn.closest('.item-swatch-more').remove();
// });


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.number-showmore');
  if (!btn) return;

  const productId = btn.dataset.productId;
  if (!productId) return;

  const swatchWrap = btn.closest('.card-swatch');
  if (!swatchWrap) return;

  const ul = swatchWrap.querySelector('ul.swatch');
  if (!ul) return;

  const dataEl = document.getElementById('swatch-data-' + productId);
  if (!dataEl) return;

  const variants = JSON.parse(dataEl.textContent);

  // ✅ TẠO group-swatch nếu chưa có
  let group = ul.querySelector('.group-swatch');
  if (!group) {
    group = document.createElement('li');
    group.className = 'group-swatch';
    group.style.display = 'none';
    ul.insertBefore(group, ul.querySelector('.item-swatch-more'));
  }

  // tránh append lại
  if (group.dataset.loaded === 'true') return;
  group.dataset.loaded = 'true';

  variants.slice(4).forEach(variant => {
    const wrapper = document.createElement('div');
    wrapper.className = 'item-wrapper clearfix';

    wrapper.innerHTML = `
      <label class="swatch-label ${variant.available === false ? 'is-soldout' : ''}"
        data-variant-id="${variant.id}"
        data-value="${variant.text}"
        ${variant.big_img ? `data-variant-img="${variant.big_img}"` : ''}>
        <span class="pattern"
          style="${variant.variant_img ? `background-image:url(${variant.variant_img});` : ''}">
        </span>
        ${variant.text}
      </label>
      <span class="tooltip">${variant.color}</span>
    `;

    group.appendChild(wrapper);
  });

  // show đúng layout cũ
  group.style.display = 'flex';

  // remove nút more
  btn.closest('.item-swatch-more')?.remove();
});
